import React from "react";
import { StyleSheet, View } from "react-native";

import { Text, Input, Button, InputLabel, LoadingBox } from "components";

import { useForm, Controller } from "react-hook-form";
import { strings } from "assets/constants";
import css from "styles";
import { useCreateCountry } from "clients/apis";

const CreateCountry = () => {
  const {
    control,
    reset,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<CreateCountryReqT>({
    defaultValues: {
      name: "",
      iso_code_2: "",
      iso_code_3: "",
    },
  });

  const createCountryMut = useCreateCountry();
  const _onSubmit = () =>
    createCountryMut.mutate(getValues(), {
      onSettled(data, error) {
        if (!error) {
          // console.log(data);
          return;
        }

        // console.log(error);
      },
    });

  return (
    <>
      <View style={styles.container}>
        <Text weight="extraBold" style={styles.title}>
          {strings.create_new_country}
        </Text>

        <>
          <InputLabel label={strings.country_name} />
          <Controller
            control={control}
            name="name"
            rules={{ required: { value: true, message: strings.fill_input } }}
            render={({ field: { value, onChange } }) => (
              <Input
                value={value}
                onChangeText={onChange}
                icon={{ name: "edit-2" }}
                placeholder={strings.country_name}
                error={errors?.name?.message}
              />
            )}
          />
        </>

        <View style={css.rRowCenterAlignSpaceBetween}>
          <View style={{ width: "49%" }}>
            <InputLabel label={strings.country_iso_code_2} />
            <Controller
              control={control}
              name="iso_code_2"
              rules={{ required: { value: true, message: strings.fill_input } }}
              render={({ field: { value, onChange } }) => (
                <Input
                  value={value}
                  onChangeText={onChange}
                  icon={{ name: "edit-2" }}
                  placeholder={strings.country_iso_code_2}
                  error={errors?.name?.message}
                />
              )}
            />
          </View>

          <View style={{ width: "49%" }}>
            <InputLabel label={strings.country_iso_code_3} />

            <Controller
              control={control}
              name="iso_code_3"
              rules={{ required: { value: true, message: strings.fill_input } }}
              render={({ field: { value, onChange } }) => (
                <Input
                  value={value}
                  onChangeText={onChange}
                  icon={{ name: "edit-2" }}
                  placeholder={strings.country_iso_code_3}
                  error={errors?.name?.message}
                />
              )}
            />
          </View>
        </View>

        <Button
          mt={15}
          width={120}
          title={{ value: strings.create }}
          onPress={handleSubmit(_onSubmit)}
        />
      </View>
      {createCountryMut?.isLoading && <LoadingBox />}
    </>
  );
};

export default CreateCountry;

const styles = StyleSheet.create({
  container: { paddingVertical: 20 },
  title: { marginBottom: 7 },
});
